function KeyManagerModalController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.key = ctrl.resolve.key;
  };

  ctrl.confirmGeneration = () => {
    ctrl.close({ $value: 'accepted' });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('modalDirectives')
  .controller('KeyManagerModalController', KeyManagerModalController);
